import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'paypal',
  scriptId: 'paypal-js',
  makeScriptUri: ({ clientId, currency = 'USD', locale = 'en_US' }) => `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}&locale=${locale}&disable-funding=credit,card`
})

export { install }
